import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FeatureCard,
  FeatureContainer,
  FeatureIcon,
  FeatureSubtitle,
  FeatureTitle,
  PlaceholderBackButton,
} from "./styles.featurePlaceholder";

const FeaturePlaceholder = ({ icon, title, subtitle }) => {
  const navigate = useNavigate();

  return (
    <FeatureContainer>
      <FeatureCard>
        <PlaceholderBackButton onClick={() => navigate(-1)}>
          <img src="/logos/back_logo.svg" alt="" width={18} height={18} />
          Back
        </PlaceholderBackButton>
        {icon ? <FeatureIcon src={icon} alt="" /> : null}
        <FeatureTitle>{title}</FeatureTitle>
        <FeatureSubtitle>{subtitle}</FeatureSubtitle>
      </FeatureCard>
    </FeatureContainer>
  );
};

export default FeaturePlaceholder;
